module.exports = __webpack_public_path__ + "static/media/EKDWXR2.ba146c03.png";